import { $getZoneByCoords, $postCustomerService } from "@/utils/endpoints";
import Vue from "vue";

export const state = () => ({
  requestWashoutAddress: "",
  requestWashoutAddressNumber: "",
  isRequestWashoutAddressNumberVisible: false,
  hasRequestWashoutAddressChanged: false,
  requestWashoutZone: null,
  requestWashoutMail: "",
  recaptchaToken: "",
});

const getters = {
  requestWashoutAddress: (state) => state.requestWashoutAddress,
  requestWashoutAddressNumber: (state) => state.requestWashoutAddressNumber,
  isRequestWashoutAddressNumberVisible: (state) =>
    state.isRequestWashoutAddressNumberVisible,
  hasRequestWashoutAddressChanged: (state) =>
    state.hasRequestWashoutAddressChanged,
  requestWashoutZone: (state) => state.requestWashoutZone,
  requestWashoutMail: (state) => state.requestWashoutMail,
  recaptchaToken: (state) => state.recaptchaToken,
};

const mutations = {
  selectRequestWashoutAddress: (state, newValue) => {
    state.requestWashoutAddress = newValue;
  },
  setHasRequestWashoutAddressChanged: (state, newValue) =>
    (state.hasRequestWashoutAddressChanged = newValue),
  setRequestWashoutAddressStreetNumber: (state, newValue) =>
    (state.requestWashoutAddressNumber = newValue),
  toggleRequestWashoutStreetNumberVisibility: (state) => {
    state.isRequestWashoutAddressNumberVisible = !state.isRequestWashoutAddressNumberVisible;
  },
  setRequestWashoutZone(state, zone) {
    state.requestWashoutZone = zone;
  },
  resetRequestWashoutZone(state) {
    state.requestWashoutZone = null;
  },
  setRequestWashoutEmail(state, value) {
    state.requestWashoutMail = value;
  },
  setRecaptchaToken(state, value) {
    state.recaptchaToken = value;
  },
};
const namespaced = true;

const actions = {
  getRequestWashoutZoneByCoords: async (
    { commit },
    { latitude, longitude }
  ) => {
    const zone = await $getZoneByCoords({
      latitude,
      longitude,
    });

    if (zone.zones && zone.zones.id) {
      // SUCCESS
      commit("setRequestWashoutZone", zone.zones.id);
    } else {
      // NOT COVERED
      commit("resetRequestWashoutZone");
    }
  },
  requestWashout: async (context, payload) => {
    await $postCustomerService(payload);
  },
  getRecaptchaToken: async ({ commit }) => {
    const token = await Vue.prototype.$recaptcha("request_washout");
    commit("setRecaptchaToken", token);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced,
};
